import { combineReducers } from 'redux';
import common from './commonReducer';
//import products from './productReducer';
import form from './formReducer';
// import doctors from './doctorReducer';
// import patients from './patientReducer';
import entity from './entityReducer';
import reports from './reportsReducer';
import dashboard from './dashboardReducer';
import { CHANGE_STORE } from 'constants/actionTypes';
import initialState from './initialState';

const appReducer = combineReducers({
    common,
    form,
    entity,
    reports,
    dashboard
});

const rootReducer = (state, action) => {
    switch (action.type) {
        case CHANGE_STORE: {
            localStorage.removeItem('TECHPOS_CompanyCode');
            localStorage.removeItem('TECHPOS_ApiUrl');
            localStorage.removeItem('TECHPOS_SELECTED_BRANCH');
            return {
                ...state,
                common: {
                    ...initialState.common,
                    authenticatedUser: state.common.authenticatedUser,
                    isUserAuthenticated: state.common.isUserAuthenticated,
                },
                form: {
                    userName: state.form.userName,
                    password: state.form.password
                },
                entity: initialState.entity,
                reports: initialState.reports,
                dashboard: initialState.dashboard
            };
        }
        default:
            return appReducer(state, action);
    }
}

export default rootReducer;